import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import ElitePerformanceShowcase from "./sections/ElitePerformanceShowcase";
import FooterInformation from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div className="!bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1702891/img/Color-logo-with-background-scaled.png)] !bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1702891/img/Color-logo-with-background-scaled.png)]">
      <MainNavigation />
      <ElitePerformanceShowcase />
      <FooterInformation />
    </div>;
}